export const KGOC_COMPANIES = [
  {
    id: "kangaro-flagship",
    name: "Kangaro — Heritage Flagship",
    sector: "Institutional & Office Stationery",
    headcount: 420,
    asbc_gap: 44800000,
    labour_cost: 280000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/kangaro-flagship-kgoc-2026",
    signal: "amber",
    urgency_reason: "Export scale-up outpacing account management capacity",
    functions: ["International Sales", "Brand Marketing", "E-commerce Operations", "Regional Distribution", "Finance"],
    competitors: [
      { name: "Kangaro — Heritage Flagship", score: 56, isTarget: true },
      { name: "Linc Limited",                score: 62 },
      { name: "Navneet Education",           score: 68 },
      { name: "Flair Writing Industries",    score: 64 },
      { name: "DOMS Industries",             score: 71 },
    ],
    velocity_headline: "Flair Writing tripling export capability in 18 months",
    leadership_scores: [6, 5, 7, 5, 6, 6, 5],
    readiness_score: 62,
    readiness_drivers: [
      "Heritage brand with 65+ year institutional accounts base",
      "Export footprint across 100+ countries needs dedicated country management",
      "E-commerce ops talent thin vs category peers",
    ],
  },
  {
    id: "miles-premium",
    name: "Miles — Premium & Export",
    sector: "Premium Stationery & Global Retail",
    headcount: 280,
    asbc_gap: 31360000,
    labour_cost: 196000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/miles-premium-kgoc-2026",
    signal: "red",
    urgency_reason: "Premium brand under-scaled vs 100-country footprint opportunity",
    functions: ["Global Key Accounts", "Premium Design", "Trade Marketing Intl", "Supply Chain Export", "Finance"],
    competitors: [
      { name: "Miles — Premium & Export", score: 42, isTarget: true },
      { name: "Cello World",              score: 68 },
      { name: "DOMS Industries",          score: 71 },
      { name: "Stabilo (Intl)",           score: 78 },
      { name: "Leitz (Intl)",             score: 76 },
    ],
    velocity_headline: "DOMS building global key account team 2\u00d7 faster",
    leadership_scores: [5, 4, 6, 5, 5, 5, 4],
    readiness_score: 48,
    readiness_drivers: [
      "Premium positioning established; commercial infrastructure behind brand value",
      "Absence of dedicated global key account leadership",
      "Design refresh cycle materially slower than international competitors",
    ],
  },
  {
    id: "munix-consumer",
    name: "Munix — Consumer Kitchen & Home",
    sector: "Kitchenware & Home Consumer",
    headcount: 340,
    asbc_gap: 38080000,
    labour_cost: 238000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/munix-consumer-kgoc-2026",
    signal: "red",
    urgency_reason: "D2C and modern trade capability gap in fastest-growing segment",
    functions: ["D2C Commerce", "Brand Content", "Modern Trade Sales", "Category Management", "Finance"],
    competitors: [
      { name: "Munix — Consumer Kitchen", score: 44, isTarget: true },
      { name: "Cello Kitchenware",        score: 72 },
      { name: "TTK Prestige",             score: 78 },
      { name: "Butterfly Gandhimathi",    score: 65 },
      { name: "Borosil Consumer",         score: 69 },
    ],
    velocity_headline: "TTK Prestige tripling D2C ops headcount in 12 months",
    leadership_scores: [4, 4, 6, 5, 5, 5, 5],
    readiness_score: 44,
    readiness_drivers: [
      "Digital commerce talent density roughly 40% of category median",
      "Brand content engine undersized for modern trade velocity",
      "Category management structure still channel-led rather than SKU-led",
    ],
  },
  {
    id: "kohe-industrial",
    name: "Kohe — Industrial Professional",
    sector: "Industrial Tools & Fastening",
    headcount: 360,
    asbc_gap: 40320000,
    labour_cost: 252000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/kohe-industrial-kgoc-2026",
    signal: "amber",
    urgency_reason: "B2B industrial tools growth capped by technical sales bench",
    functions: ["Technical Sales", "Industrial Distribution", "Product Engineering", "After-sales Service", "Finance"],
    competitors: [
      { name: "Kohe — Industrial Professional", score: 54, isTarget: true },
      { name: "Taparia Tools",                  score: 66 },
      { name: "Jhalani Tools",                  score: 58 },
      { name: "Stanley Black & Decker India",   score: 78 },
      { name: "JK Files (Raymond)",             score: 62 },
    ],
    velocity_headline: "Stanley B&D India growing technical salesforce at 25% CAGR",
    leadership_scores: [5, 5, 6, 6, 5, 6, 5],
    readiness_score: 55,
    readiness_drivers: [
      "Installed base substantial but predictive service tooling absent",
      "Technical sales engineers below 60% of benchmark density",
      "Product engineering strong; go-to-market talent is the constraint",
    ],
  },
  {
    id: "shared-manufacturing-platform",
    name: "Shared Manufacturing & R&D Platform",
    sector: "Precision Manufacturing Infrastructure",
    headcount: 2800,
    asbc_gap: 275100000,
    labour_cost: 1834000000,
    currency: "INR",
    demo_url: "https://app.reaimagination.com/demo/shared-manufacturing-kgoc-2026",
    signal: "red",
    urgency_reason: "6 hubs, 8 facilities — Industry 4.0 and AI-driven QC is the next frontier",
    functions: ["Industry 4.0 Capability", "AI-driven Quality Control", "Precision Tooling Design", "Supply Chain Digitisation", "Manufacturing Operations"],
    competitors: [
      { name: "KGOC Shared Manufacturing", score: 39, isTarget: true },
      { name: "Sundaram Fasteners",        score: 74 },
      { name: "Bharat Forge",              score: 82 },
      { name: "Endurance Technologies",    score: 71 },
      { name: "Motherson Sumi",            score: 79 },
    ],
    velocity_headline: "Sundaram Fasteners completing smart-factory rollout across 4 plants",
    leadership_scores: [4, 3, 6, 5, 7, 5, 4],
    readiness_score: 41,
    readiness_drivers: [
      "200+ quality engineers still predominantly manual inspection",
      "Data infrastructure across 6 manufacturing hubs fragmented",
      "ML/data engineering talent not yet embedded in manufacturing ops",
    ],
  },
];
